import {useEffect, useState} from 'react';

export const useResize = (debounceDelay = 200) => {
  const [isResizing, setIsResizing] = useState(false);

  useEffect(() => {
    let resizeTimeout;

    const handleResize = () => {
      if (!isResizing) {
        setIsResizing(true);
      }
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        setIsResizing(false);
      }, debounceDelay);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isResizing, debounceDelay]);

  return isResizing;
};
